import { Route, AppId, createPageRoute } from '@lumapps/router';

export const promotedResultsAdminRoute: Route = createPageRoute({
    slug: 'promoted-results',
    id: 'promoted-content',
    appId: AppId.backOffice,
});

export const promotedResultsAdmin = (): Route => promotedResultsAdminRoute;
